(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearnerViewSBCourseModalCtrl", ["$window", "$uibModalInstance", "$location", "authService", "launchValues", learnerViewSBCourseModalCtrl]);
    function learnerViewSBCourseModalCtrl($window, $uibModalInstance, $location, authService, launchValues) {
        var vm = this;
        vm.isMobile = jQuery.browser.mobile || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        vm.launchUrl = launchValues.legacyCourseViewerURL +
            "?a=" + launchValues.activationId +
            "&p=" + authService.authentication.userPersonSeq +
            "&lms=" + $location.protocol() + "://" + $location.host() + ":" + $location.port();
        //console.log("Is Mobile", vm.isMobile);
        //console.log("LAUNCH URL", vm.launchUrl);
        vm.openCourse = function () {
            $window.open(vm.launchUrl, "_blank", "");
        };
        vm.close = function () {
            $uibModalInstance.close();
        };
        if (vm.isMobile) {
            vm.openCourse();
        }
    }
}());
